const RECOMMEND_FLOAT_LIST = [
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/lhym50bm_780962.png',
    text: '成单即享',
    tip: '推荐新客，成单奖励2888元起',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/lhyt0y7a_348901.png',
    text: '不设上限',
    tip: '多邀多得，成单奖励累加无上限',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/li1f857q_568486.png',
    text: '任选推荐',
    tip: '标准化产品、定制化产品均可参与',
  },
];

const RECOMMEND_PROCESS_LIST = [
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/lholslur_540578.png',
    text: '加入瑶台推荐官',
    tip: '填写个人信息，立即开启推荐',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/lholslus_540578.png',
    text: '分享链接/海报，提交线索',
    tip: '获取专属链接/海报<br/>或直接提交新用户信息',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/li1f7zxv_561650.png',
    text: '新用户购买网易瑶台产品',
    tip: '新用户在注册后90天内<br/>首次购买网易瑶台产品即可获得奖励',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/li1f83gm_566214.png',
    text: '奖励发放',
    tip: '奖励将在新用户合同内容执行完毕<br/>并全部回款后的10个工作日内发放',
  },
];
const RECOMMEND_PROCESS_LIST_MOBILE = [
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/lholslur_540578.png',
    text: '加入瑶台推荐官',
    tip: '填写个人信息，立即开启<br/>推荐',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/lholslus_540578.png',
    text: '分享链接/海报，提交线索',
    tip: '获取专属链接/海报，或直接提交新用户信息',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/li1f7zxv_561650.png',
    text: '新用户购买网易瑶台产品',
    tip: '新用户在注册后90天内首次<br/>购买瑶台产品即可获得奖励',
  },
  {
    ico: 'https://static.fuxi.netease.com/yaotai/portal/index/li1f83gm_566214.png',
    text: '奖励发放',
    tip: '奖励将在新用户合同内容执行完毕并全部回款后的10个工作日内发放',
  },
];
const RECOMMEND_RULE_LIST = [
  {
    text: '1. 活动时间：2023年6月20日 - 2023年9月30日。',
  },
  {
    text: '2. 参与对象：本活动仅限个人参与，网易伏羲员工以及各类合作伙伴机构不享受此次活动。',
  },
  {
    text: '3. 参与产品：网易瑶台标准化产品、定制化产品均可参与活动。',
  },
  {
    text: '4. 参与方式：推荐者分享自己的推广链接，推荐新用户注册并购买网易瑶台产品，即可获取购物卡奖励。',
  },
  {
    text: '5. 推荐关联有效期：从提交线索/邀请注册日起，90天内首次购买，算为推荐成功。',
  },
  {
    text: '6. 奖励规则：',
    child: [
      '（1）推荐新用户成单，首次购买金额<50万，奖励 2888 元购物卡；',
      '（2）新用户首次购买金额50万（含50万）-100万（不含100万），奖励提升至 18888 元购物卡；',
      '（3）新用户首次购买金额100万（含100万）-500万（不含500万），奖励提升至 38888 元购物卡；',
      '（4）新用户首次购买金额≥500万，奖励提升至 88888 元购物卡；',
      '（5）以新用户首次签订合同金额为准，奖励将在新用户合同内容执行完毕并全部回款后的10个工作日内发放。',
    ],
  },
  {
    text: '7. 奖励发放：',
    child: [
      '（1）购物卡可任意选择网易严选卡或京东卡，以上奖励金额均为税前金额，奖励有关税费由用户个人承担；',
      '（2）我们将在新用户合同内容执行完毕并全部回款后的10个工作日内发放成单奖励；',
      '（3）新用户首次付费下单，推荐人可享受成单奖励，老客户复购/续费、升级订单不参与奖励；',
      '（4）如果同一新用户被多人推荐并成单，奖励归属第一位推荐人；',
      '（5）如果被推荐用户出现以下情况，则该订单无法参与奖励。',
    ],
    roundText: [
      '被推荐用户已在瑶台相关渠道进行留资咨询（判断维度：注册/登录IP、手机号、注册邮箱、企业主体、项目）',
      '被推荐用户已有合作伙伴团队直接服务',
      '新用户及其协作者账号与推荐者被判为同一个人或同一家企业（例如：同注册/登录IP、同手机号、同注册邮箱、同企业主体）',
    ],
  },
  {
    text: '8. 本次推荐有奖活动不可与网易瑶台其他营销活动同享。',
  },
  {
    text: '9. 如有作弊行为及其它违规行为，网易瑶台有权取消奖励或要求退回奖励。',
  },
  {
    text: '10. 网易瑶台尊重并保护用户隐私，参与活动所填写的用户信息仅用于本次活动。',
  },
];

// 用于PC端扫码拼接参数,直接打开移动端海报弹框
const OPEN_RECOMMEND_SHARE = 'open_recommend_share';

export {
  RECOMMEND_FLOAT_LIST,
  RECOMMEND_PROCESS_LIST,
  RECOMMEND_RULE_LIST,
  OPEN_RECOMMEND_SHARE,
  RECOMMEND_PROCESS_LIST_MOBILE,
};
